import { buildContentUrl, ContentItem, fetchUrls } from 'omni-package-react-cms';
import { Content } from '~/interfaces/Content';
import Configuration from '~/utils/Configuration';
import logger from '../utils/logger';

export const fetchContent = async (locale: string): Promise<Partial<Content>> => {
  const config = Configuration.Current();
  const urls: string[] = [];
  if (config.mockingEnabled) {
    urls.push('/api/ssc/aggregate/content/Items/help/');
    urls.push('/api/ssc/aggregate/content/Items/businessHours/');
  } else {
    urls.push(buildContentUrl('Need Help/Phone number', false, locale));
    urls.push(buildContentUrl('Need Help/Business Hours', false, locale));
  }
  const contents: ContentItem[] = await fetchUrls(urls, logger);

  return {
    needHelp: contents[0],
    businessHours: contents[1],
  };
};
